<div class="dialog-container">
  <div mat-dialog-content class="text-center">
    キーワード未入力のままだと、インフルエンサーには「その他」とのみ表示されます。よろしいですか？
  </div>
  <div class="mat-dialog-actions" mat-dialog-actions>
    <button mat-raised-button (click)="modalRef.close(false)">
      戻って入力する
    </button>
    <button mat-raised-button color="primary" (click)="modalRef.close(true)">
      このまま保存
    </button>
  </div>
</div>
